import Store from '@/store/store'

Store.registerModule('style', {
    namespaced: true,
    state: {
        currentTheme: localStorage.getItem("newCurrentTheme")? localStorage.getItem("newCurrentTheme"): 'theme-11',//当前主题类
        currentNavItemColor: localStorage.getItem("newCurrentNavItemColor")? localStorage.getItem("newCurrentNavItemColor"): '#3f497e',//当前菜单背景色
        smallViewportSize: 769,//小视口尺寸
        isSmView: false, //是否处于小视口状态下
        sideShrink: false,//隐藏左侧菜单
        

    },
    getters: {
        
    },
    mutations: {
        setCurrentTheme(state, currentTheme){
            state.currentTheme = currentTheme;
            localStorage.setItem("newCurrentTheme", currentTheme);
            
        },

        setIsSmView(state, type){
            state.isSmView = type;
        },
        setSideShrink(state, type){
            state.sideShrink = type;
        },
        setCurrentNavItemColor(state, currentNavItemColor){
            state.currentNavItemColor = currentNavItemColor;
            localStorage.setItem("newCurrentNavItemColor", currentNavItemColor);
            
        },

    },
    actions: {

    }
})